import { useCallback } from 'react';

import { WebStorage } from '../../../../../hooks/useWebStorage';
import { SCHEDULE_EXPORT_DRAFT } from '../../../../../utils/web-storage-keys';

const draftStorage = new WebStorage(window.sessionStorage);

export const scheduleExportDraftKey = (reportId) => `${SCHEDULE_EXPORT_DRAFT}${reportId ?? 'new'}`;

export const clearScheduleExportDraft = (reportId) => {
  draftStorage.removeItem(scheduleExportDraftKey(reportId));
};

const useScheduleExportDraft = (report) => {
  const key = scheduleExportDraftKey(report?.id);

  const getDraft = useCallback(() => draftStorage.getItem(key), [key]);
  const setDraft = useCallback((value) => draftStorage.setItem(key, value), [key]);
  const clearDraft = useCallback(() => draftStorage.removeItem(key), [key]);

  return { getDraft, setDraft, clearDraft };
};

export default useScheduleExportDraft;
